export const DDLT_SIZE_CAPTURE_VERSION = 1;
